export enum ErrorType {
    NO_DATA_TO_SHOW = 'no_data_to_show',
    SERVER_CONNECTION_ERROR = 'serverConnectionError',
    NO_SUITABLE_PEOPLE_COUNTER_COLUMNS_SELECTION_ERROR = 'noSuitablePeopleCounterColumnsSelectedError',
    UNAUTHORIZED = 'UnauthorizedException'
}
